import {
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Maquinas from './pages/Maquinas';
import Toners from './pages/Toners';
import RegistroToner from './pages/RegistroToner';
import Registros from './pages/Registros';
import EnvioCliente from './pages/EnvioCliente';
import HistorialEnvios from './pages/HistorialEnvios';
import Usuarios from './pages/Usuarios';
import { useEffect } from 'react';

// Protege una ruta. Se puede exigir:
//   - roles:   lista de roles permitidos (ej: ['admin'])
//   - permiso: nombre de un permiso (ej: 'gestionar_maquinas')
// Los administradores siempre pasan la verificación de permiso.
function RequireAuth({ children, roles, permiso }) {
  const user = useAuthStore(state => state.user);
  const puede = useAuthStore(state => state.puede);

  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  if (permiso && !puede(permiso)) return <Navigate to="/dashboard" replace />;
  return children;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  // Las llaves {} son importantes: sin ellas, la flecha DEVUELVE el resultado de
  // window.scrollTo(), y React lo trata como función de limpieza (cleanup). Como no es
  // una función, al desmontar fallaba con "destroy is not a function" y rompía la app.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function AppRoutes() {
  const user = useAuthStore(state => state.user);
  const location = useLocation();
  const hideNavbar = location.pathname === '/login';

  return (
    <>
            <ScrollToTop />
            {!hideNavbar && <Navbar />}
            <Routes>
                <Route
                path="/"
                element={
                    user
                    ? <Navigate to="/dashboard" replace />
                    : <Navigate to="/login" replace />
                }
                />
                <Route
                path="/login"
                element={
                    user
                    ? <Navigate to="/dashboard" replace />
                    : <Login />
                }
                />
                <Route
                path="/dashboard"
                element={
                    <RequireAuth roles={['admin', 'secretaria']}>
                    <Dashboard />
                    </RequireAuth>
                }
                />
                <Route
                path="/clientes"
                element={
                    <RequireAuth roles={['admin', 'secretaria']}>
                    <Clientes />
                    </RequireAuth>
                }
                />
                <Route
                path="/maquinas"
                element={
                    <RequireAuth permiso="gestionar_maquinas">
                    <Maquinas />
                    </RequireAuth>
                }
                />
                <Route
                path="/toners"
                element={
                    <RequireAuth permiso="gestionar_toners">
                    <Toners />
                    </RequireAuth>
                }
                />
                <Route
                path="/registro-toner"
                element={
                    <RequireAuth roles={['admin', 'secretaria']}>
                    <RegistroToner />
                    </RequireAuth>
                }
                />
                <Route
                path="/registros"
                element={
                    <RequireAuth roles={['admin', 'secretaria']}>
                    <Registros />
                    </RequireAuth>
                }
                />
                <Route
                path="/envio-cliente"
                element={
                    <RequireAuth roles={['admin', 'secretaria']}>
                    <EnvioCliente />
                    </RequireAuth>
                }
                />
                <Route
                path="/historial-envios"
                element={
                    <RequireAuth permiso="ver_historial">
                    <HistorialEnvios />
                    </RequireAuth>
                }
                />
                <Route
                path="/usuarios"
                element={
                    <RequireAuth roles={['admin']}>
                    <Usuarios />
                    </RequireAuth>
                }
                />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
    </>
  );
}